import { render, staticRenderFns } from "./insurance-optional.vue?vue&type=template&id=457184e6"
import script from "./insurance-optional.vue?vue&type=script&lang=js"
export * from "./insurance-optional.vue?vue&type=script&lang=js"
import style0 from "./insurance-optional.vue?vue&type=style&index=0&id=457184e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports